<template>
  <b-navbar class="havas-background" fixed-top
  :mobile-burger="false">
    <template slot="brand">
      <b-navbar-item class="pl-20">
        <img ref="logo" v-if="urlLogo"
          :alt="monSite"
          :class="classLogo"
          :src="urlLogo"
        >
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const User = createNamespacedHelpers('user');
const Recommandation = createNamespacedHelpers('recommandation');

export default {
  props: {
    monSite: String,
    urlLogoSociete: {
      type: String,
      required: false,
      default: '',
    }
  },
  mounted () {
      // if (this.site === "havas") {
      //   this.$refs.logo.src = "https://affixe2staging.blob.core.windows.net/attachments/49/Societe/15365205-9365-426c-b720-d53b16d83ffc/HavasUMT_logoV2.jpg"
      // }
      // else
      // {
      //   this.$refs.logo.src = "https://affixe2staging.blob.core.windows.net/attachments/49/Societe/15365205-9365-426c-b720-d53b16d83ffc/HavasUMT_logoV2.jpg"
      // }
  },
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    ...Recommandation.mapGetters({
      societe: 'societe',
    }),
    classLogo() {
      var nomClass =  "general-logo"
      this.monSite === "Affichage Autorisé" ? nomClass = "aa-logo" : nomClass =  "general-logo" ;
      return nomClass;
    },
    urlLogo() {
      return  this.societe?.urlLogo ?? this.urlLogoSociete;
    },
  },
}
</script>

<style>

</style>